import script from "./GradientSquare.vue?vue&type=script&setup=true&lang=js"
export * from "./GradientSquare.vue?vue&type=script&setup=true&lang=js"

import "./GradientSquare.vue?vue&type=style&index=0&id=71d92055&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d92055"]])

export default __exports__